import React from "react"
import Typography from "@material-ui/core/Typography"
import Box from "@material-ui/core/Box"
import PropTypes from "prop-types"
import makeStyles from "@material-ui/core/styles/makeStyles"
import useSmartFormat from "../../i18n/useSmartFormat"

const useStyles = makeStyles((theme) => ({
  root: {
    // keep a consistent size when there is a selector
    // on same row as children or not
    height: 60,
    maxHeight: 60,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    display: "flex",
    alignItems: "center"
  },
  title: {
    borderLeft: `8px solid ${theme.palette.secondary.main}`,
    "&:first-child": {
      paddingLeft: theme.spacing(2)
    }
  },
  subTitle: {
    fontSize: 18,
    marginTop: 5,
    color: "#3f4752"
  }
}))

export default function PageSubTitle(props) {
  const { subtitle, description, children } = props
  const classes = useStyles()
  const format = useSmartFormat()

  return (
    <Box className={classes.root}>
      <Box flexGrow={1} mb={2}>
        <Box className={classes.title}>
          <Typography color="secondary" variant="h5">
            {format(subtitle)}
          </Typography>
        </Box>
        {description && (
          <Typography color="textPrimary" variant="subtitle1" gutterBottom>
            {description}
          </Typography>
        )}
      </Box>
      {children}
    </Box>
  )
}

PageSubTitle.defaultProps = {
  children: <></>,
  description: undefined
}

PageSubTitle.propTypes = {
  children: PropTypes.any,
  description: PropTypes.string,
  subtitle: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired
}
